module.exports = "/public/images/0d53b32f19773f4f89f9a280854796c8.svg";